import { Outlet } from 'react-router-dom'
import { Header } from '@trafiflow/shared-ui'
import { useAuth } from '@trafiflow/shared-ui'
import { MarketingSidebar } from './MarketingSidebar'
import { OnboardingGuard } from './OnboardingGuard'
import { MetaConnectionProvider } from '@/shared/contexts/MetaConnectionContext'

export function MarketingLayout() {
  const { user, logout } = useAuth()

  const handleLogout = async () => {
    try {
      await logout()
      window.location.href = '/login'
    } catch (error) {
      console.error('Error logging out:', error)
    }
  }

  return (
    <div className="flex min-h-screen bg-tf-bg-muted">
      <MarketingSidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Header
          user={
            user
              ? {
                  id: user.userId,
                  email: user.email,
                  name: user.email.split('@')[0],
                  tenant_id: user.tenantId,
                  role: user.roles?.[0],
                }
              : null
          }
          onLogout={handleLogout}
          searchPlaceholder="Search..."
          showSearch={true}
        />
        <main className="flex-1 overflow-auto">
          <OnboardingGuard>
            <MetaConnectionProvider>
              <Outlet />
            </MetaConnectionProvider>
          </OnboardingGuard>
        </main>
      </div>
    </div>
  )
}

export default MarketingLayout
